var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.texto)?_c('div',{staticClass:"observacao"},[_c('label',[_vm._v("OBSERVAÇÕES")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.strReplace(_vm.texto,'<a','<a target=\'_blank\' '))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }